export enum PreactionSystemTypeEnum {
  SingleInterlock = 'single interlock',
  NonInterlock = 'non interlock',
  DoubleInterlock = 'double interlock'
}
